export const OPPOSITE_SCROLL_RESTORE_TOLERANCE_PX = 5;

export function getScrollKeyDirection(key: string, shiftKey = false): -1 | 0 | 1 {
  switch (key) {
    case "ArrowUp":
    case "PageUp":
    case "Home":
      return -1;
    case "ArrowDown":
    case "PageDown":
    case "End":
      return 1;
    case " ":
      return shiftKey ? -1 : 1;
    default:
      return 0;
  }
}

export function shouldRestoreOppositeScrollJump({
  key,
  shiftKey = false,
  beforeScrollTop,
  afterScrollTop,
  tolerance = OPPOSITE_SCROLL_RESTORE_TOLERANCE_PX,
}: {
  key: string;
  shiftKey?: boolean;
  beforeScrollTop: number;
  afterScrollTop: number;
  tolerance?: number;
}): boolean {
  const direction = getScrollKeyDirection(key, shiftKey);
  if (direction === 0) return false;

  const delta = afterScrollTop - beforeScrollTop;
  return direction < 0 ? delta > tolerance : delta < -tolerance;
}

export function isEditableKeydownTarget(target: EventTarget | null | undefined): boolean {
  if (!(target instanceof Element)) return false;
  const tagName = target.tagName;
  if (tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT") return true;
  return target.closest("[contenteditable='true'], [contenteditable=''], [role='textbox']") != null;
}

export function shouldTreatKeydownAsScrollIntent(event: Pick<KeyboardEvent, "key" | "shiftKey" | "target">): boolean {
  if (isEditableKeydownTarget(event.target)) return false;
  return getScrollKeyDirection(event.key, event.shiftKey) !== 0;
}
